(function () {
  "use strict";

  var armData = {
    A: [
      { name: "Short", overall: "Not offered", socket: "Not offered", note: "RAM does not list a Short A Size arm.", available: false },
      { name: "Medium", overall: "53.6 mm / 2.11 in", socket: "42.4 mm / 1.67 in", note: "The usual A Size arm length.", available: true },
      { name: "Long", overall: "90.4 mm / 3.56 in", socket: "79.3 mm / 3.12 in", note: "Extra reach for very light equipment.", available: true }
    ],
    B: [
      { name: "Short", overall: "61.5 mm / 2.42 in", socket: "44.5 mm / 1.75 in", note: "Compact, low-profile positioning.", available: true },
      { name: "Medium", overall: "94.7 mm / 3.73 in", socket: "76.2 mm / 3.00 in", note: "Balanced reach for everyday setups.", available: true },
      { name: "Long", overall: "152.4 mm / 6.00 in", socket: "134.9 mm / 5.31 in", note: "More reach, with greater leverage.", available: true }
    ],
    C: [
      { name: "Short", overall: "90.4 mm / 3.56 in", socket: "63.5 mm / 2.50 in", note: "Keeps heavier devices close to the base.", available: true },
      { name: "Medium", overall: "144.5 mm / 5.69 in", socket: "118.4 mm / 4.66 in", note: "The usual C Size reach.", available: true },
      { name: "Long", overall: "231.9 mm / 9.13 in", socket: "203.2 mm / 8.00 in", note: "Extended positioning for supported setups.", available: true }
    ],
    D: [
      { name: "Short", overall: "129.5 mm / 5.10 in", socket: "91.4 mm / 3.60 in", note: "Compact heavy-duty positioning.", available: true },
      { name: "Medium", overall: "214.4 mm / 8.44 in", socket: "174.8 mm / 6.88 in", note: "The usual D Size reach.", available: true },
      { name: "Long", overall: "329.7 mm / 12.98 in", socket: "289.8 mm / 11.41 in", note: "Long heavy-duty reach for suitable installations.", available: true }
    ],
    E: [
      { name: "Short", overall: "185.7 mm / 7.31 in", socket: "126.5 mm / 4.98 in", note: "Shorter specialist heavy-duty arm.", available: true },
      { name: "Medium", overall: "320.8 mm / 12.63 in", socket: "251.0 mm / 9.88 in", note: "Medium E Size reach.", available: true },
      { name: "Long", overall: "Not offered", socket: "Not offered", note: "RAM does not list a Long E Size arm.", available: false }
    ]
  };

  var familyData = {
    A: { diameter: "14.3 mm / 9/16 inch", standard: "Holds up to 0.23 kg / 0.5 lb", heavy: "No heavy-duty capacity published by RAM", uses: "Very small, low-profile equipment", copy: "Pair A Size ball components with A Size socket arms. A Size is uncommon and intended for very light equipment." },
    B: { diameter: "25.4 mm / 1 inch", standard: "Holds up to 0.91 kg / 2 lb", heavy: "Holds up to 0.45 kg / 1 lb", uses: "Phones, GPS and lighter setups", copy: "Pair B Size ball components with B Size socket arms. Other arm families do not fit directly." },
    C: { diameter: "38.1 mm / 1.5 inch", standard: "Holds up to 1.81 kg / 4 lb", heavy: "Holds up to 1.36 kg / 3 lb", uses: "Tablets, scanners and rougher use", copy: "Pair C Size ball components with C Size socket arms. C Size SKUs normally begin RAM- without another size letter." },
    D: { diameter: "57.2 mm / 2.25 inch", standard: "Holds up to 2.72 kg / 6 lb", heavy: "Holds up to 2.27 kg / 5 lb", uses: "Fishfinders, monitors and heavy equipment", copy: "Pair D Size ball components with D Size socket arms. D Size is built for heavier and more demanding applications." },
    E: { diameter: "85.9 mm / 3.38 inch", standard: "Holds up to 6.80 kg / 15 lb", heavy: "Holds up to 4.54 kg / 10 lb", uses: "Specialist very-heavy equipment", copy: "Pair E Size ball components with E Size socket arms. E Size is a specialist system and is rarely needed for everyday mounting." }
  };

  function armMarkup(arm, compact) {
    var lengthClass = arm.name.toLowerCase();
    var unavailable = arm.available ? "" : '<span class="mm-sg-unavailable">Not offered in this family</span>';

    if (compact) {
      return '<article class="mm-sg-mini-arm">' +
        '<span class="mm-sg-arm-icon mm-sg-arm-icon--' + lengthClass + '" aria-hidden="true"></span>' +
        '<div><h4>' + arm.name + '</h4><p><strong>Overall length:</strong> ' + arm.overall + '</p><small>' + arm.note + '</small>' + unavailable + '</div>' +
      '</article>';
    }

    return '<article class="mm-sg-arm-card">' +
      '<span class="mm-sg-arm-icon mm-sg-arm-icon--' + lengthClass + '" aria-hidden="true"></span>' +
      '<h3>' + arm.name + ' arm</h3>' +
      '<p><strong>Overall length:</strong> ' + arm.overall + '</p>' +
      '<p><strong>Socket-to-socket:</strong> ' + arm.socket + '</p>' +
      '<p>' + arm.note + '</p>' + unavailable +
    '</article>';
  }

  function setSelected(buttons, active, attribute) {
    buttons.forEach(function (button) {
      var selected = button === active;
      button.setAttribute(attribute, String(selected));
    });
  }

  function renderPageFamily(page, family) {
    var compatibility = page.querySelector("[data-mm-sg-family-compatibility]");
    var grid = page.querySelector("[data-mm-sg-arm-grid]");
    if (!compatibility || !grid || !armData[family]) return;

    compatibility.textContent = family + " Size arms connect to " + family + " Size ball components.";
    grid.innerHTML = armData[family].map(function (arm) { return armMarkup(arm, false); }).join("");
  }

  function renderModalFamily(modal, family) {
    var data = familyData[family];
    if (!data) return;

    var productSizesValue = modal.getAttribute("data-product-sizes") || "";
    var productSizes = productSizesValue ? productSizesValue.split("/").map(function (size) { return size.trim(); }) : [];
    var initial = modal.getAttribute("data-initial-family") || "B";
    var productNote = modal.querySelector("[data-mm-sg-product-note]");
    var comparisonNote = modal.querySelector("[data-mm-sg-comparison-note]");
    var art = modal.querySelector("[data-mm-sg-art]");

    modal.querySelector("[data-mm-sg-modal-title]").textContent = family + " Size compatibility guide";
    modal.querySelector("[data-mm-sg-modal-heading]").textContent = family + " Size uses a " + data.diameter + " ball";
    modal.querySelector("[data-mm-sg-modal-copy]").textContent = data.copy;
    modal.querySelector("[data-mm-sg-standard]").textContent = data.standard;
    modal.querySelector("[data-mm-sg-heavy]").textContent = data.heavy;
    modal.querySelector("[data-mm-sg-uses]").textContent = data.uses;
    var facts = modal.querySelector(".mm-sg-facts");
    if (facts) facts.setAttribute("aria-label", family + " Size guidance");

    if (art) {
      art.className = "mm-sg-art mm-sg-art--" + family.toLowerCase();
      art.setAttribute("aria-label", "Official " + family + " Size round ball base drawing");
    }

    modal.querySelector("[data-mm-sg-modal-arms]").innerHTML = armData[family].map(function (arm) { return armMarkup(arm, true); }).join("");

    if (comparisonNote) {
      var isProductFamily = productSizes.indexOf(family) !== -1;
      comparisonNote.hidden = productSizes.length === 0 || isProductFamily;
      if (productSizes.length > 0 && !isProductFamily) comparisonNote.textContent = "You are viewing " + family + " Size for comparison. This product remains " + productSizes.join(" / ") + " Size.";
    }

    if (productNote && productSizes.length > 1) {
      productNote.textContent = "This product connects the " + productSizes.join(" Size and ") + " Size mounting systems. The guide opens on " + initial + " Size, and you can compare either family below.";
    }
  }

  function initialisePage(page) {
    var buttons = Array.prototype.slice.call(page.querySelectorAll("[data-mm-sg-family]"));
    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        setSelected(buttons, button, "aria-pressed");
        renderPageFamily(page, button.getAttribute("data-mm-sg-family"));
      });
    });
  }

  function initialiseModal(modal) {
    var initial = modal.getAttribute("data-initial-family") || "B";
    var buttons = Array.prototype.slice.call(modal.querySelectorAll("[data-mm-sg-modal-family]"));
    var initialButton = buttons.filter(function (button) { return button.getAttribute("data-mm-sg-modal-family") === initial; })[0];
    if (initialButton) setSelected(buttons, initialButton, "aria-pressed");
    renderModalFamily(modal, initial);
  }

  function init() {
    document.querySelectorAll("[data-mm-sg-page]").forEach(initialisePage);
    document.querySelectorAll("[data-mm-sg-modal]").forEach(initialiseModal);
  }

  document.addEventListener("click", function (event) {
    var button = event.target.closest("[data-mm-sg-modal-family]");
    if (!button) return;
    var modal = button.closest("[data-mm-sg-modal]");
    if (!modal) return;
    var buttons = Array.prototype.slice.call(modal.querySelectorAll("[data-mm-sg-modal-family]"));
    setSelected(buttons, button, "aria-pressed");
    renderModalFamily(modal, button.getAttribute("data-mm-sg-modal-family"));
  });

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
